<div class="flex flex-col px-3 pb-3 bg-gray-000 rounded-b-2xl">
	<div class="relative z-10 bg-gray-000">
		<div class="flex items-center justify-between gap-1">
			<span class="flex min-w-0 items-center gap-1">
				@if (symbol().icon; as icon) {
					<ui-icon width="24" height="24" class="shrink-0 text-gray-900" [iconName]="icon" />
				}
				<span class="truncate text-base font-bold text-gray-900">{{ symbol().name }}</span>
			</span>
			<span class="shrink-0 text-lg font-bold text-gray-900">
				<ui-number format="1.0-0" [value]="symbol().lastPrice" />
			</span>
		</div>

		<div class="flex items-center justify-between gap-1">
			<span class="min-w-0 truncate text-xs text-gray-500">{{ symbol().subtitle }}</span>
			<span
				class="shrink-0 text-sm font-medium"
				[class.text-green-500]="!lastPriceDown()"
				[class.text-red-500]="lastPriceDown()">
				<span [class.text-gray-900]="!lastPriceUp() && !lastPriceDown()"
					>(%<ui-number dir="ltr" [value]="symbol().lastPriceChangePercent" [maxDigit]="2" />)</span
				>&ngsp;<ui-number format="1.0-0" dir="ltr" [value]="symbol().lastPriceChange" />
			</span>
		</div>
	</div>

	<div
		class="grid transition-[grid-template-rows] duration-300 ease-out"
		[class.grid-rows-[1fr]]="!collapsed()"
		[class.grid-rows-[0fr]]="collapsed()"
		[attr.aria-hidden]="collapsed()"
		[inert]="collapsed()">
		<div class="min-h-0 overflow-hidden">
			<div
				class="flex items-center justify-between gap-1 pt-2 transition-[translate,opacity] duration-300 ease-out"
				[class.-translate-y-full]="collapsed()"
				[class.opacity-0]="collapsed()">
				<div class="flex items-center gap-1 text-3.25">
					<span class="text-gray-600 whitespace-nowrap"> قیمت پایانی:</span>
					<span
						[class.text-green-500]="closingPriceUp()"
						[class.text-red-500]="closingPriceDown()"
						[class.text-gray-900]="!closingPriceUp() && !closingPriceDown()">
						(%<ui-number dir="ltr" [value]="symbol().closingPriceChangePercent" [maxDigit]="2" />)
					</span>
					<ui-number format="1.0-0" class="text-gray-900" [value]="symbol().closingPrice" />
				</div>
				<div class="flex items-center gap-1 text-3.25">
					<span class="text-gray-600">حجم:</span>
					<ui-number format="1.0-0" class="text-gray-900" [value]="symbol().volume" />
				</div>
			</div>
		</div>
	</div>
</div>
